import { Switch, Tooltip, useTheme } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"

interface Props {
    value?: boolean
    disabled?: boolean
    onChange: (value: boolean) => void
}

export const AutoArmToggle = ({ onChange, value, disabled }: Props) => {
    const { t } = useTranslation()
    const theme = useTheme()

    const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.checked
        onChange(newValue)
    }

    return (
        <Tooltip title={value ? t("dialog.auto_arm.disable_tooltip") : t("dialog.auto_arm.enable_tooltip")}>
            <span>
                <Switch
                    checked={value}
                    disabled={disabled}
                    onChange={handleToggle}
                    sx={{ color: theme.palette.primary.main }}
                />
            </span>
        </Tooltip>
    )
}
